import { Button, styled } from "@mui/material";

export const ActionButton = styled(Button)(({ theme }) => ({
	minWidth: "41.61px",
	paddingLeft: 0,
	paddingRight: 0,
	minHeight: "41.61px",
	marginTop: "41.44px",
	[theme.breakpoints.down("sm")]: {
		marginTop: "10px",
	},
}));
